export default "__VITE_ASSET__D0GvkRJM__"